import { styled } from "@mui/material/styles";

// Components
import CategoryIcon from "../CategoryIcon";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { ReactComponent as DropDownIcon } from "~/assets/icons/sort-down-solid.svg";

// Theme
import { theme } from "~/components/Common";

const styledName = "CategoryItem";

export const StyledItem = styled(TreeItem, { name: styledName })({
  "&": {
    marginTop: "4px",
    position: "relative",
    ".MuiTreeItem-content": {
      transition: "all 0.3s ease-in",
      borderRadius: "10px",
      ":hover": {
        svg: {
          fill: theme.palette.primary.main,
        },
      },
    },
  },
});

export const StyledLabel = styled("div", { name: styledName })({
  "&": {
    width: "100%",
    height: "50px",
    display: "flex",
    alignItems: "center",
  },
});

export const StyledIcon = styled(CategoryIcon, { name: styledName })({
  "&": {
    height: "36px",
    width: "36px",
    marginRight: "30px",
  },
});

// child icon
export const StyledItemChild = styled(TreeItem, { name: styledName })({
  "&": {
    ".MuiTreeItem-content": {
      transition: "all 0.3s ease-in",
      borderRadius: "10px",
    },
  },
});

export const StyledLabelChild = styled("div", { name: styledName })({
  "&": {
    width: "100%",
    height: "40px",
    display: "flex",
    alignItems: "center",
  },
});

export const StyledIconChild = styled(CategoryIcon, { name: styledName })({
  "&": {
    height: "30px",
    width: "30px",
    marginRight: "30px",
  },
});

export const StyledDropDown = styled(DropDownIcon, { name: styledName })({
  "&": {
    position: "absolute",
    height: "14px",
    left: "-10px",
    fill: theme.palette.grey[600],
  },
});
